import React from "react";
import { Link } from "react-router-dom";
import EssenceActionsDropdown from "../../Essence/EssenceActionsDropdown";
import EssenceStateLabel from "../../Essence/EssenceStateLabel";
import Fav from "../../Misc/Fav";
import SVGDock from "../../Misc/SvgIcons/SVGDock";
import SVGSteering1 from "../../Misc/SvgIcons/SVGSteering1";
import { getTypedocByKey } from "../Workdoc/typedoc";
export default function TrackerListItem(props) {
  let values = [];
  for (let field in props) values.push(field);

  const iconColor = props.typecode === "cruise.tracker" ? "primary" : "info";
  let datestart = props.datestart
    ? new Date(props.datestart).toLocaleString()
    : null;
  let datestop = props.datestop
    ? new Date(props.datestop).toLocaleString()
    : null;

  return (
    <>
      <Link to={`/tracker/${props.mode}/${props.id}/`}>
        <div
          className={`row py-4  border-bottom text-dark bg-hover-light ${
            props.highlightItem === String(props.id) ? "bg-light" : ""
          }`}
        >
          <div
            style={{ wordBreak: "break-word" }}
            className="col-lg-10 m-lg-0 my-3"
          >
            <div className="mb-2">
              {props.label}

              <Fav className="ml-1" itemId={props.id} item={props} />
            </div>

            <>
              <div className="small d-flex">
                <div className="mr-3 text-primary ">{props.shipname}</div>
                <div className="mr-3 text-dark-75 ">
                  {props.departurename}{" "}
                  {props.arrivalname !== props.departurename && (
                    <>- {props.arrivalname}</>
                  )}
                </div>
              </div>
              <div className="text-dark-50 small">
                {datestart} {datestop && <> - {datestop}</>}
              </div>
            </>
          </div>

          <div className="col-lg-2  d-flex align-items-center justify-content-end text-right">
            <EssenceStateLabel
              stateCode={props.statetypecode}
              stateLabel={props.statelabel}
              essence="tracker"
              id={props.id}
            />
            <EssenceActionsDropdown
              essence={"tracker"}
              key={props.id}
              id={props.id}
              label={props.label}
              onFinish={props.onFinish}
            />
          </div>
        </div>
      </Link>
    </>
  );
}
